// extracted by mini-css-extract-plugin
export default {"app":"App_app__kjqwC","appDark":"App_appDark__MvJsQ","feedTitle":"App_feedTitle__9OZMW","grid":"App_grid__RcWsi","dark-theme":"App_dark-theme__40Zh5"};